import { cn } from "@babybjorn/ui";
import type { FC, HTMLAttributes, PropsWithChildren } from "react";

type ThreeUpProps = PropsWithChildren<
	HTMLAttributes<HTMLDivElement> & {
		headline?: string;
		label?: string;
		notThree?: boolean;
	}
>;
/**
 * This is used for both ThreeUp and TwoUp
 */
const ThreeUp: FC<ThreeUpProps> = ({
	headline,
	children,
	label,
	notThree = false,
}) => {
	return (
		<div className="flex flex-col gap-6 lg:gap-10">
			<label className={cn({ hidden: !label })}>{label}</label>
			<h2 className={cn({ hidden: !headline })}>{headline}</h2>
			<section
				className={cn("gap-bb grid grid-cols-1", {
					"justify-center md:grid-cols-2": notThree,
					"md:grid-cols-3": !notThree,
				})}
			>
				{children}
			</section>
		</div>
	);
};

export default ThreeUp;
